import * as React from 'react';
import './style.scss';

interface Props {
    className?: string;
}
const AddOnPriceTag: React.FC<Props> = ({ className }) => {
    return <div className={`add-on-price-tag ${className}`}>加購價</div>;
};

export default AddOnPriceTag;
